
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Contact() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-6">
              Contact Us
            </h1>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Information */}
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-8">Get In Touch</h2>
              
              <div className="space-y-8">
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-map-pin-line text-[#9B1F3A] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Office Location</h3>
                    <p className="text-gray-600">
                      1340 Smith Avenue, Suite 300<br />
                      Baltimore, MD 21209<br />
                      United States
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-phone-line text-[#9B1F3A] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Phone</h3>
                    <p className="text-gray-600">(410) 630-6990</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-mail-line text-[#9B1F3A] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Email</h3>
                    <p className="text-gray-600">info@canalgroup.us</p>
                  </div>
                </div>
              </div>

              <div className="mt-12">
                <img 
                  src="https://public.readdy.ai/ai/img_res/938d9c235ab01fecfcdbaf82066ca570.jpg"
                  alt="Meridian Development Office"
                  className="w-full h-64 object-cover object-top shadow-lg"
                />
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-gray-50 p-8">
              <h2 className="text-3xl font-bold text-gray-800 mb-8">Send Us a Message</h2>
              
              <form 
                className="space-y-6" 
                data-readdy-form 
                id="contact-form"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const formData = new FormData(e.target as HTMLFormElement);
                  const data = new URLSearchParams();
                  
                  formData.forEach((value, key) => {
                    data.append(key, value.toString());
                  });
                  
                  try {
                    const response = await fetch('https://readdy.ai/api/form/d3qk2250m2pbt9esgp1g', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                      },
                      body: data,
                    });
                    
                    if (response.ok) {
                      alert('Message sent successfully! We will get back to you soon.');
                      (e.target as HTMLFormElement).reset();
                    } else {
                      alert('Failed to send message. Please try again.');
                    }
                  } catch (error) {
                    alert('Failed to send message. Please try again.');
                  }
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2">
                      First Name *
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      required
                      className="w-full px-4 py-3 border border-gray-300 focus:ring-2 focus:ring-[#9B1F3A] focus:border-transparent text-sm"
                    />
                  </div>
                  <div>
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2">
                      Last Name *
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      required
                      className="w-full px-4 py-3 border border-gray-300 focus:ring-2 focus:ring-[#9B1F3A] focus:border-transparent text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 focus:ring-2 focus:ring-[#9B1F3A] focus:border-transparent text-sm"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 border border-gray-300 focus:ring-2 focus:ring-[#9B1F3A] focus:border-transparent text-sm"
                  />
                </div>

                <div>
                  <label htmlFor="projectType" className="block text-sm font-medium text-gray-700 mb-2">
                    Project Type
                  </label>
                  <div className="relative">
                    <select
                      id="projectType"
                      name="projectType"
                      className="w-full px-4 py-3 pr-8 border border-gray-300 focus:ring-2 focus:ring-[#9B1F3A] focus:border-transparent text-sm appearance-none bg-white"
                    >
                      <option value="">Select a project type</option>
                      <option value="commercial">Commercial Development</option>
                      <option value="residential">Residential Development</option>
                      <option value="industrial">Industrial Development</option>
                      <option value="mixed-use">Mixed-Use Development</option>
                      <option value="consultation">Development Consultation</option>
                      <option value="other">Other</option>
                    </select>
                    <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                  </div>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={6}
                    required
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 focus:ring-2 focus:ring-[#9B1F3A] focus:border-transparent text-sm resize-vertical"
                    placeholder="Please describe your project requirements and how we can help you..."
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">Maximum 500 characters</p>
                </div>

                <Button
                  type="submit"
                  size="lg"
                  className="w-full"
                >
                  Send Message
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Find Our Office</h2>
          <div className="w-full h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3087.8234567890123!2d-76.6413!3d39.3643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c81c72bf0b7c0d%3A0x1234567890abcdef!2s1340%20Smith%20Ave%2C%20Baltimore%2C%20MD%2021209%2C%20USA!5e0!3m2!1sen!2sus!4v1635959385076!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
